module.exports = __webpack_public_path__ + "static/media/ribbon2Entry.3aeb1ed0.svg";